import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router } from 'react-router-dom';
import store from './store';
import { Provider } from 'react-redux';
import LearnService from './services/learn-service';
import LearnServiceContext from './components/learn-service-context';

const learnService = new LearnService();

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <LearnServiceContext.Provider value={learnService}>
        <Router>
          <App />
        </Router>
      </LearnServiceContext.Provider>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
